import React from 'react';
import { RECONNECTION_CONFIG } from '../config/reconnection.config';

/**
 * Component for successful reconnection state
 */
const ReconnectionSuccess = ({ displayName }) => {
  return (
    <div 
      className="reconnection-success"
      role="alert"
      aria-live="polite"
      aria-label={RECONNECTION_CONFIG.ARIA_LABELS.SUCCESS}
    >
      <i 
        className="pi pi-check-circle success-icon" 
        aria-hidden="true"
      />
      <h3>¡Conectado!</h3>
      <p>La conexión se ha establecido correctamente.</p>
    </div>
  );
};

export default ReconnectionSuccess;
